import { processSteps } from "@/mocks/homeData";
import { useEffect, useRef, useState } from "react";

export default function ProcessSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="process"
      ref={sectionRef}
      className="py-16 md:py-24 bg-dark-950"
    >
      <div className="px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-900 text-primary-300 text-xs font-semibold tracking-wider uppercase mb-4">
            How We Operate
          </span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-white mb-4">
            How We Operate
          </h2>
          <p className="text-dark-300 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            Simple and straightforward. We pull your report, you get a one-on-one consultation, and we get back to you in 48 hours.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {processSteps.map((step, index) => (
            <div
              key={step.id}
              className={`relative p-6 md:p-7 rounded-xl bg-dark-900 border border-dark-800 transition-all duration-500 ${
                visible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: visible ? `${index * 150}ms` : "0ms" }}
            >
              <div className="w-12 h-12 rounded-lg bg-primary-600 flex items-center justify-center mb-5">
                <i className={`${step.icon} text-white text-xl`} />
              </div>
              <div className="text-primary-400 text-xs font-bold tracking-wider uppercase mb-3">
                Step {step.id}
              </div>
              <h3 className="font-heading font-semibold text-lg text-white mb-3">
                {step.title}
              </h3>
              <p className="text-dark-300 text-sm leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}